
export enum GameStatuses {
    draft,
    active,
    paused,
    closed
}
export enum GameStatuses {
    draft,
    active,
    paused,
    closed
}